import { CardInstance } from './card';

// マッチの状態
export type MatchStatus = 'waiting' | 'inProgress' | 'finished';

// バトル中のフィールド状態
export interface FieldState {
  flagHolder: CardInstance | null;   // 現在フラッグ保持カード
  challenger: CardInstance | null;   // 挑戦中カード
  bench: CardInstance[];             // ベンチ
  exile: CardInstance[];             // 除外ゾーン
  deckRemaining: number;             // デッキ残り枚数
}

// プレイヤーごとのバトル状態
export interface BattlePlayerState {
  playerId: string;
  field: FieldState;
  isAttacker: boolean;  // 現在攻撃側か
}

// マッチ全体の状態
export interface MatchState {
  matchId: string;
  round: number;
  status: MatchStatus;
  players: [BattlePlayerState, BattlePlayerState];
  turnCount: number;
  log: BattleLogEntry[];
  winner?: string;  // 勝者のplayerId
}

// バトルログエントリ
export interface BattleLogEntry {
  turn: number;
  action: BattleAction;
  playerId: string;
  cardId?: string;
  message: string;
}

// バトルアクション種別
export type BattleAction =
  | 'reveal'        // カード公開
  | 'flagTaken'     // フラッグ奪取
  | 'toBench'       // ベンチへ退場
  | 'abilityTrigger'// 能力発動
  | 'matchEnd';     // マッチ終了

// マッチ結果
export interface MatchResult {
  matchId: string;
  round: number;
  winnerId: string;
  loserId: string;
  winnerFansGained: number;
  winnerFlags: number;  // 勝者が獲得したフラッグ数
  finalState: MatchState;
}

// ファン獲得量 (ラウンドごとに増加)
export const FANS_PER_ROUND: Record<number, number> = {
  1: 1,
  2: 1,
  3: 2,
  4: 2,
  5: 3,
  6: 3,
  7: 4,
  8: 5,  // 決勝
};
